export default __webpack_public_path__ + "static/media/map1.8b241aba.png";